import React from 'react'

import { useJobDetails } from './hooks'
import { JobDetailsTabs } from './JobDetailsTabs'

export const JobDetails = () => {
  const { state, handlers } = useJobDetails()

  const {
    activeTab,
    project,
    tabs,
    hasInterviewModule,
    hasInterviewTemplate,
    isInterviewAvailable,
  } = state
  const { handleTabChange } = handlers

  return (
    <JobDetailsTabs
      activeTab={activeTab}
      project={project}
      tabs={tabs}
      hasInterviewModule={hasInterviewModule}
      hasInterviewTemplate={hasInterviewTemplate}
      isInterviewAvailable={isInterviewAvailable}
      onTabChange={handleTabChange}
    />
  )
}
